import kr from '../kr/kr';
import Swiper from 'swiper/bundle';

export default class SliderProduct extends kr.Component {
    init() {
        this._sliderEl = this.$element.querySelector('.swiper-subpage');
        if (this._sliderEl == null) {
            return false;
        }
        this.initiateSlider();
    }
    initiateSlider(){

        const args = {
            loop: false,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            touchEventsTarget: 'wrapper',
            autoplay: {
                delay: 5000,
            },
        }
        
        const next = this.$element.querySelector('.swiper-button-next');
        const prev = this.$element.querySelector('.swiper-button-prev');

        if (next && prev) {
            args.navigation = {
                nextEl: next,
                prevEl: prev,
            }
        }

        const swiper = new Swiper(this._sliderEl, args);

        const seeVideoButton = this.$element.querySelector('.js-sliderButtonIsVideo');
        if (seeVideoButton != null) {
            seeVideoButton.addEventListener('click', ()=> {
                const index = this._findFirstVideo(swiper.slides);
                if (index > 0) {
                    swiper.slideTo(index);
                }
                
            });
        }       
    }
    
    _findFirstVideo(slides) {
        let index = 0;
        for (let i in slides) {
            const attr = slides[i].getAttribute('data-type');
            if (attr == 'youtube' || attr == 'video') {
                index = i;
                break;
            }
        };

        return index;
    }
}

kr.registerComponent('.product-slider', {
    component: SliderProduct
});
